<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div class="brief-form">
          <div
            class="
              form__input-wrapper
              form__input-wrapper--check
              form__input-wrapper--check-squer
            "
            v-for="checkbox in formCheckboxes"
            :key="checkbox.name"
          >
            <input
              class=""
              :id="checkbox.name"
              type="checkbox"
              :name="checkbox.name"
              :value="checkbox.value"
              v-model.trim="form.otherServices"
              @input="manageOptions"
              @click="hasDescription = false"
            />
            <label 
            :for="checkbox.name"
            class="form__label"
            :class="{'circle-check': checkbox.name === 'os-nothing'}"
            >
              {{ checkbox.label }}
              <Tooltip v-if="checkbox.tooltip" :title="checkbox.tooltip" />
            </label>
          </div>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';
import Tooltip from '../global/tooltip.vue';

export default {
  name: 'OtherServices',
  components: { Tooltip, BriefStep },
  mixins: [stepValidation],
  data: () => ({
    title:
      'Wiadomo, że apetyt rośnie w miarę jedzenia. Czy oprócz strony potrzebujesz '
      + 'czegoś jeszcze?',
    form: {
      otherServices: [],
    },
    formCheckboxes: [
      {
        name: 'os-seo',
        value: 'pozycjonowanie',
        label: 'pozycjonowanie',
        tooltip: 'Współpracujemy z kilkoma specjalistami od SEO.',
      },
      {
        name: 'os-social',
        value: 'prowadzenie social media',
        label: 'prowadzenie social media',
        tooltip:
          'Jesteśmy w stanie podjąć się kompleksowego prowadzenia portali '
          + 'społecznościowych, takich jak Instagram, Facebook czy Linkedin.',
      },
      {
        name: 'os-logo',
        value: 'przygotowanie logo firmy',
        label: 'przygotowanie logo firmy',
        tooltip:
          'Nasza oferta obejmuje przygotowanie 3 propozycji w różnych wersjach '
          + 'oraz 2-krotne poprawki.',
      },
      {
        name: 'os-foto-video',
        value: 'sesja foto / video',
        label: 'sesja foto / video',
      },
      {
        name: 'os-nothing',
        value: 'nie potrzebuję niczego więcej',
        label: 'nie potrzebuję niczego więcej',
      },
    ],
  }),
  validations: {
    form: {
      otherServices: {
        required,
      },
    },
  },
  methods: {
    manageOptions(e) {
      if (e.target.value === 'nie potrzebuję niczego więcej') {
        this.form.otherServices = [e.target.value];
        if (this.hasDescription) {
          this.otherHandler();
        }
      } else {
        this.form.otherServices = this.form.otherServices.filter((el) => el !== 'nie potrzebuję niczego więcej');
      }
      this.invokeTouch(this.$v.form.otherServices)
    },
  },
};
</script>
